import { useDispatch, useSelector } from "react-redux";

import { CircularProgress } from "@mui/material";

import Author from "./Author";

import AppPageShell from "./AppPageShell";

import DashboardTopBar from "./DashboardTopBar";

import { useEffect, useMemo } from "react";

import { getGamesData, getProfile } from "../redux/asyncThunk/userActions";
import { CONTENT_TYPES, resolveGameContentType } from "../utils/contentType";

export default function Dashbord() {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.user?.status);

  const user = useSelector((state) => state.user?.data?.user);

  const profile = useSelector((state) => state.user?.profile);
  const games = useSelector((state) => state.user?.games);

  const dashboardGames = useMemo(
    () =>
      (games ?? []).filter(
        (game) => resolveGameContentType(game) !== CONTENT_TYPES.knowledge_base,
      ),
    [games],
  );

  useEffect(() => {
    if (user?.id) {
      dispatch(getGamesData({ id: user.id }));

      dispatch(getProfile({ id: user.id }));
    }
  }, [dispatch, user.id]);

  if (isLoading) {
    return (
      <div className="app-main">
        <div className="app-loading">
          <CircularProgress />
        </div>
      </div>
    );
  }

  return (
    <div className="app-main">
      <AppPageShell className="app-page--dashboard" title="Рабочий стол">
        <DashboardTopBar
          businessSubscription={profile?.businessSubscription}
          storage={profile?.storage ?? null}
          games={dashboardGames}
          teamUsage={profile?.teamUsage ?? null}
        />

        <Author />
      </AppPageShell>
    </div>
  );
}
